import * as H from 'highcharts';
import worldMap from './world_map.json';
import * as Highmaps from 'highcharts/modules/map';

const showInLegendCheck = (proceed, item) => {
  if (item.showInLegend !== false) {
    proceed.call(this, item);
  }
};

// wraps for legendCheck
H.wrap(H.Legend.prototype, 'renderItem', showInLegendCheck);
H.wrap(H.Legend.prototype, 'positionItem', showInLegendCheck);

// load maps
Highmaps(H);
H.maps['custom/world-robinson'] = worldMap;

/*
This is required for proper timezone handling. Otherwise the dates may be
shifted because the start date will be in a different timezone than the rest.
We want to show the user dates in their own timezone and this is the default
for most libraries. Highcharts defaults to UTC for some reason.
*/
H.setOptions({
  global: {
    useUTC: false,
  },
});

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { H as default, H as Highcharts };
